







































































































































































import { Vue, Component, Ref, Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from "vuex-class";
import {
  Collapse, NewPriceWings, SelectWings,
  SpoilerWings, ToggleWings, NumberWings
} from "wings-ui-components";
import {cloneDeep, isEqual} from "lodash";
import { notifyConfirm, notifyDelete, notifyError } from "@/utils/notify-helper";
import { TariffZoneItem, TarificationTransports, TarificationTypes } from "@/store/tarification/types";
import { extend } from 'vee-validate';
import { removeItem } from '@/utils/data-helper';
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {
    SelectWings, NewPriceWings, ToggleWings,
    Collapse, SpoilerWings, NumberWings,
  },
})
export default class TariffZone extends Vue {

  @Prop() transport!: TarificationTransports;
  @Prop() type!: TarificationTypes;

  @Ref('validator') validator: any;

  @Action("getTariffZoneItem") actionGetItem: any;
  @Action("saveTariffZoneItem") actionSave: any;
  @Action("deleteTariffZoneItem") actionDelete: any;
  @Action("getTariffZoneGroupItem") actionGetTGZItem: any;
  @Action("getTariffZones") actionGetTariffZones: any;

  @Action("getMessageCategories") actionGetMessageCategories: any;
  @Action("actionLog") actionLog: any;

  @Getter("tariffZoneGroup") tariffZoneGroup: any;
  @Getter("tariffZones") tariffZonesList!: TariffZoneItem[];

  @Getter("messageCategories") messageCategoriesList: any;

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();

  private selectedCategories = [];
  private useCategories: boolean = false;
  private logObject: ActionLog = {};

  get isOperatorType(): boolean {
    return this.type === TarificationTypes.OPERATOR;
  }

  defaultItem(): TariffZoneItem {
    return {
      id: undefined,
      name: "",
      msisdn: undefined,
      mcc: undefined,
      mnc: undefined,
      price: undefined,
      status: 1,
      message_categories_prices: undefined,
    };
  }

  async created() {
    await this.actionGetMessageCategories({transport: this.transport});
    let object = {
      partner_id: this.$route.params.partner_id,
      operator_id: this.$route.params.operator_id,
      id: this.$route.params.id,
      transport: this.transport.toLowerCase()
    };
    this.actionGetTGZItem(object)
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Tariff zone",
          addititional_info: getTranslatedParams({ partner: this.$route.params.partner_id, service_provider: this.$route.params.operator_id })
        }
        await this.actionGetItem(object).then((data: TariffZoneItem) => {
          this.item = Object.assign({}, this.item, data);
          this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
          this.actionLog(this.logObject);
        });
       } catch(e){
        await this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
    this.actionGetTariffZones({
      transport: this.transport.toLowerCase(),
      partner_id: this.$route.params.partner_id,
      operator_id: this.$route.params.operator_id,
    });
    this.validationSetup();
    if (this.item.message_categories_prices && this.item.message_categories_prices.length) {
      this.useCategories = true;
    } else {
      this.useCategories = false;
    }
  }

  validationSetup() {
    extend('tz_name_unique', {
      validate: (value: any) => {
        let tariffZonesNamesList: string[] = this.tariffZonesList
            .map((tariffZone: TariffZoneItem) => tariffZone.name);
        if (this.$route.params.id) {
          const itemProviderName: string | undefined = this.tariffZonesList
              .find((tariffZone: TariffZoneItem) => tariffZone.id?.toString() == this.$route.params.id)
              ?.name;
          tariffZonesNamesList = tariffZonesNamesList.filter((name: string) => name != itemProviderName);
        }
        const result: boolean = !tariffZonesNamesList.includes(value);
        return result;
      },
      message: 'Запись с идентичным именем уже существует', // TODO: i18n
    });
  }

  back(): void {
    this.$router.push(`/${this.transport.toLowerCase()}/tarification/${this.type}/`);
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid:boolean = await this.validator.validate();
      if (valid) {
        // при отправке mcc/mnc = '' (пустой строки) - ошибка валидации на сервере
        if (this.item.mcc === '') this.item.mcc = undefined;
        if (this.item.mnc === '') this.item.mnc = undefined;
        let object = {
          partner_id: this.$route.params.partner_id,
          operator_id: this.$route.params.operator_id,
          item: this.item,
          transport: this.transport.toLowerCase()
        };
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "Tariff zone",
            addititional_info: getTranslatedParams({...this.item, ...{ partner: this.$route.params.partner_id, service_provider: this.$route.params.operator_id }})
          }
          await this.actionSave(object);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          resolve()
          this.back();
        } catch (error) {
          this.actionLog({...this.logObject, action_status: "failed"});
          reject();
          notifyError(error);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors)
        }, 100);
      }
    });
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      let object = {
        partner_id: this.$route.params.partner_id,
        operator_id: this.$route.params.operator_id,
        item: this.item,
        transport: this.transport.toLowerCase()
      };
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Tariff zone",
          object_name: this.item.name,
          addititional_info: getTranslatedParams({ partner: this.$route.params.partner_id, service_provider: this.$route.params.operator_id })
        }
        await this.actionDelete(object);
        this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  get status():number {
    return this.item.status
  }

  set status(value:number) {
    this.item.status = (value ?? 0)
  }

  public beforeLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }


  /** Далее функционал категорий:
   *
   * TODO: Все это дело лучше вынести куда-то. Например в отдельный компонент, и наследоваться от него.
   * (Повторение в ./Tariff.vue)
   *
  */

  // Из vue-material.md-table
  onSelect(items: any) {
    this.selectedCategories = items;
  }

  // Добавить строку в табл. категорий
  addEmptyCategory(): void {
    if (this.item.message_categories_prices === undefined) {
      this.item.message_categories_prices = [];
    }
    this.item.message_categories_prices.push({message_category_id: undefined, price: undefined});
  }

  // Удаление строки/строк из табл. категорий
  deleteSelectedCategories(): void {
    if (this.item.message_categories_prices) {
      this.selectedCategories.forEach((rule: any) =>
        removeItem(this.item.message_categories_prices, rule));
      if (this.item.message_categories_prices.length === 0) {
        this.addEmptyCategory();
      }
    }
  }

  // Инициализация и очистка таблицы категорий при вкл-выкл свитча useCategories
  @Watch('useCategories')
  onChangeItemUseCategoriesPrices(newVal: boolean) {
    if (newVal) {
      if (this.item.message_categories_prices === undefined)
        this.item.message_categories_prices = []
      if (this.item.message_categories_prices.length === 0)
        this.addEmptyCategory();
    } else {
      this.item.message_categories_prices = undefined;
    }
  }
}
